import React, { Component } from 'react';
import RenderField from './RenderField';
import {reduxForm, Field} from 'redux-form';
import generateValidator from './Validations/generateValidator';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import Section from './Section.js';
import AttributeOptions from './AttributeOptions.js';
import CustomSpinner from './CustomSpinner.js';
import SaveStepButton from './SaveStepButton';
import Whatsapp from './WhatsappButton.js';

class LastSales extends Component {
    constructor(props){
        super(props);

        this.state = {
            has_property: null,
        };
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;
        const property_options = [{id:0 , name:'Si'}, {id:1 , name:'No'}]

        return (

             <Section className="intro_form">
                <div className="row">
                <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                    <div className="show-desktop">
                        <Whatsapp phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                        <SaveStepButton/>
                    </div>
                    </div>
                     <div className="pd-content-right text-center short-content col-sm-12 col-md-7 col-lg-7">
                         <form onSubmit={handleSubmit(this.props.infoLastSales)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                                <div className="form-group">
                                    <Field className="form-control" name="last_sales" autoComplete="off" component={RenderField} type="currency" label="Ingresá las ventas de los ultimos 12 meses" maxChars={500} showSuccess={true} />
                                </div>
                                    <div className="form-group">
                                        <AttributeOptions name="has_property" defaultValue="¿Es titular de un inmueble?" label="¿Es titular de un inmueble?" attributeName='has_property' attributeOptions={property_options}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                            <Whatsapp phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                          <SaveStepButton/>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

LastSales.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

LastSales = TopScrolleable(LastSales);
let validate = generateValidator([{name: 'last_sales', required: true},{name: 'has_property', required: true}]);

LastSales = reduxForm({
    form: 'LastSales', // a unique name for this form
    validate
})(LastSales);

LastSales = withAuthControl(LastSales);

export default LastSales;



/** WEBPACK FOOTER **
 ** ./src/components/LastSalesForm.js
 **/